
import { HddOutlined, CloseCircleOutlined, SearchOutlined, PlusCircleOutlined, LockOutlined, UserOutlined, CreditCardOutlined, MailOutlined, PhoneOutlined, EditOutlined, DeleteOutlined, ExperimentOutlined, FundOutlined, FolderAddOutlined, AreaChartOutlined } from '@ant-design/icons';

import { Col, DatePicker, Empty, Form, InputRef, Row, TableColumnsType, Tooltip } from 'antd';
import { Button, Input, Space, Table, Modal, InputNumber, Select, Drawer } from 'antd';
import type { ColumnsType, ColumnType } from 'antd/es/table';
import type { FilterConfirmProps, TableRowSelection } from 'antd/es/table/interface';
import React, { useRef, useState, useEffect } from 'react';
import style from '../Tables.module.scss'
import {
    getAllOrganization, getValidateOrganization, putActiveOrganization, postRegisterOrganization, putUpdateOrganization,
    getOrganizationById, deleteInactiveOrganization, deleteOrganizationById,
    getOrganizationsByParentOrganizationId,
    postOrganizationsByParentOrganizationId,
    deleteOrganizationsByParentOrganizationId,
    getTypeOrganization
} from '../../../../store/organization/thunks';
import { connect } from 'react-redux';
import { AppState } from '../../../../store';
import moment from 'moment';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { validateIdentification, validateLetters, validatePhoneEC, validateBirthday, validateNumber, validateDigitLength, validateLettersAndLength, validate150, validateAndLength } from '../../../../globals/Inputs/validateInput';
import validateMessages from '../../../../globals/Inputs/validateMessages';
import { typesIdentification } from '../../../../globals/Parameters/listParameters';
import locale from 'antd/lib/date-picker/locale/es_ES';
import { Organization } from '../../../../store/organization/types';
import { openNotification } from '../../../../globals/Components/Notification/Notificaction';
import { deleteEmissionsOrganization, getAllEmissionsTable, getEmissionsOrganization, postResgisterEmissionsOrganization } from 'src/store/emissions/thunks';
import { getAllTransformation, GetTransformationById, postRegisterTransformation, putUpdateTransformation } from "src/store/transformationfactors/thunks";
import { EmissionsSource, TypeOrganization } from 'src/store/emissions/types';
import { TransformationSource } from 'src/store/transformationfactors/types';
import { useHistory } from 'react-router-dom';
import { getAllCountry } from 'src/store/catalogue/thunks';
import { Country } from 'src/store/catalogue/types';
import LoadingIndicator from 'src/globals/Components/Loading/LoadingIndicator';
import AdminHeader from 'src/globals/Layout/Admin/AdminHeader';
import TUser from '../TUser';
import { getAllUsersPortfolioTable } from 'src/store/user/thunks';
import { getPortfolio, postPortfolio, putStatusPortfolio, putPortfolio, getActivityDataPortfolio, postInactiveOrganizationParent, getOrgObservations } from 'src/store/portfolio/thunks';
import { isPortfolioAssociate, readRememberedRole } from 'src/auth/portfolioAssociate';
import { ActivityDataPortfolio, Loan } from 'src/store/portfolio/types';
import { Popconfirm } from "antd";
import { NULL } from 'sass';
import dayjs, { Dayjs } from 'dayjs';
import TGeiInventoryPortafolio from './TGeiInventoryPortafolio';
import TextArea from 'antd/es/input/TextArea';
import ResultsUnified from '../../Result/ResultsUnified';



interface UserTableProps {

    organizationsTable?: [] | any;
    organizationObject?: DataTypePortafolio;
    postOrganizationsByParentOrganizationId?: any;
    getTypeOrganization?: any;
    postInactiveOrganizationParent?: any;
    getOrgObservations?: any;

    getAllOrganization?: any;
    getValidateOrganization?: any;
    putActiveOrganization?: any;
    postRegisterOrganization?: any;
    putUpdateOrganization?: any;
    getOrganizationById?: any;
    deleteInactiveOrganization?: any;
    getAllEmissionsTable?: any;
    getEmissionsOrganization?: any;
    postResgisterEmissionsOrganization?: any;
    deleteEmissionsOrganization?: any;
    deleteTransformationOrganization?: any;
    getAllTransformation?: any;
    GetTransformationById?: any;
    postRegisterTransformation?: any;
    putUpdateTransformation?: any;
    deleteOrganizationById?: any;
    getAllCountry?: any;
    getOrganizationsByParentOrganizationId?: any;
    deleteOrganizationsByParentOrganizationId?: any;
    getAllUsersPortfolioTable?: any;
    getPortfolio?: any;
    postPortfolio?: any;
    putStatusPortfolio?: any;
    putPortfolio?: any;
    getActivityDataPortfolio?: any;
    editView?: any;
}

export interface DataTypePortafolio {
    key: string;
    id: string;
    ruc: string;
    name: string;
    economicActivity: string;
    description: string;
    msCatalogueCountryId: string;
    msCatalogueCountryName: string;
    organizationParentId: string;
    parentOrganizationId: string;
    status: string;
    type: string;
    typeId: string;
    createdAt: string;
}

export interface Organizations {
    key: string;
    id: string;
    ruc: string;
    name: string;
    economicActivity: string;
    description: string;
    msCatalogueCountryId: string;
    msCatalogueCountryName: string;
    status: string;
    createdAt: string;
}


interface DataTypeEmission {
    key: string;
    category_name: string;
    emissionOrganizationId: string;
    id: string;
    categoryId: string;
    name: string;
    type: string;
    flow: string;
    co2: string;
    ch4: string;
    n20: string;
    brand: string;
    series: string;
    unit: string;
    description: string;
    createdAt: string;
    updatedAt: string;
}



interface DataTypeTransformation {
    key: string;
    id: string;
    transformationOrganizationId: string;
    name: string;
    property: string;
    flow: string;
    unit: string;
    fact: number;
    source: string;
    createdAt: string;
    updatedAt: string;
}

type DataIndex = keyof DataTypePortafolio;
type DataIndexEmission = keyof DataTypeEmission;
type RequiredMark = boolean | 'optional';
const TPortafolioOrganizations: React.FC<UserTableProps> = (props: UserTableProps) => {
    const portfolioReadOnly = Boolean(props.editView) || isPortfolioAssociate(readRememberedRole());
    const [isActivityDataPortfolio, setActivityDataPortfolio] = useState<ActivityDataPortfolio[] | undefined>();
    const [isActivityDataModal, setActivityDataModal] = useState(false);
    const [isType, setType] = useState(true);
    const [dataTableOrganization, setDataTableOrganization] = useState([]);
    const [formInactivePortfolio] = Form.useForm();
    const dateFormat = 'YYYY-MM-DD';
    const [form] = Form.useForm();
    const [formPortfolio] = Form.useForm();
    const [formValidate] = Form.useForm();
    const { Option } = Select;
    const [dataTable, setDataTable] = useState([]);
    const history = useHistory();
    const [searchText, setSearchText] = useState('');
    const [motivo, setMotivo] = useState("");
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef<InputRef>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpenForm, setIsModalOpenForm] = useState(false);
    const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);
    const [isModalValidateUser, setIsModalValidateUse] = useState(false);
    const [isModalValidateInactiveUser, setIsModalValidateInactiveUser] = useState(false);
    const [typeModal, setTypeModal] = useState(true);
    const [componentSize, setComponentSize] = useState<SizeType | 'default'>('default');
    const [userData, setUserData] = useState<DataTypePortafolio>();
    const [isFormValidate, setIsFormValidate] = useState(true);
    const [requiredMark, setRequiredMarkType] = useState<RequiredMark>('optional');
    const [isModalEmision, setIsModalEmision] = useState(false);
    const [IsModalTransformation, setIsModalTransformation] = useState(false);
    const [searchValue, setSearchValue] = useState<EmissionsSource>();
    const [searchValueT, setSearchValueT] = useState<TransformationSource>();
    const [isId, setIsId] = useState("");
    const [isIdT, setIsIdTransformation] = useState("");

    const [isCountry, setIsCountry] = useState<Country[]>([]);
    const [selectedCountry, setSelectedCountry] = useState<Country | undefined>();

    const [dataTableEmissions, setDataTableEmissions] = useState([]);
    const [selectDataTableEmissions, setSelectDataTableEmissions] = useState([]);
    const [selectDataTableTypeOrganization, setSelectDataTableTypeOrganization] = useState<TypeOrganization[]>([]);

    const [dataTableTransformation, setDataTableTransformation] = useState([]);
    const [selectDataTableTransformation, setSelectDataTableTransformation] = useState([]);

    const [dataTableUser, setDataTableUser] = useState([]);

    const [validateEmptyData, setValidateEmptyData] = useState(false);
    const [isModalDeleteOrg, setIsModalDeleteOrg] = useState(false)
    const [isModalPortfolio, setIsModalPortfolio] = useState(false);

    const [isResults, setIsResults] = useState(false);

    const [dataTablePortfolio, setDataTablePortfolio] = useState([]);
    const [isLoan, setIsLoan] = useState<Loan>();
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [openPopconfirmId, setOpenPopconfirmId] = useState<string | null>(null);

    const init = async () => {




    }
    useEffect(() => {
        init();
    }, []);

    const showPopconfirm = (id: string) => {
        setOpenPopconfirmId(id);
    };

    const handleCancelPop = () => {
        setOpenPopconfirmId(null);
    };

    const handleSearch = (
        selectedKeys: string[],
        confirm: (param?: FilterConfirmProps) => void,
        dataIndex: DataIndex,
    ) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters: () => void) => {
        clearFilters();
        setSearchText('');
    };

    const getColumnSearchProps = (dataIndex: DataIndex, title: string): ColumnType<DataTypePortafolio> => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={`Buscar ${title}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Buscar
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Reiniciar
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes((value as string).toLowerCase()),
        onFilterDropdownOpenChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },

    });

    const handleOpenModalPortafolio = async (record: DataTypePortafolio) => {
        // const responseData = await props.getPortfolio(record.organizationParentId);
        // setDataTablePortfolio(responseData);
        setIsModalPortfolio(true);
        setUserData(record);
        formPortfolio.resetFields();
        setType(true);
    };


    const columns: ColumnsType<DataTypePortafolio> = [
        {
            title: '',
            width: 10,
            dataIndex: 'key',
            key: 'key',


        },
        {
            title: '',
            width: 0,
            dataIndex: 'id',
            key: 'id',
            render: () => null,
        },
        {
            title: '',
            width: 0,
            dataIndex: 'msCatalogueCountryId',
            key: 'msCatalogueCountryId',
            render: () => null,
        },
        {
            //cOMO YO QUIERO QUE APAREZCA
            title: 'Nombre',
            width: 60,
            //TA LCUAL COMO SE DECLARA EN EL DATATYPE
            dataIndex: 'name',
            //SE ENVIA EL MISMO QUE EL DATATYPE
            key: 'name',
            //MANTENER FORMATO
            //fixed: 'left',
            //BUSCADOR MODIFICADO PARA ESPANOL
            ...getColumnSearchProps('name', 'nombre'),
            sorter: (a, b) => {
                const dateA = new Date(a.name);
                const dateB = new Date(b.name);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },
        },
        {
            title: 'RUC',
            width: 50,
            dataIndex: 'ruc',
            key: 'ruc',
            //fixed: 'left',
            ...getColumnSearchProps('ruc', 'ruc'),
        },

        {
            title: 'Actividad económica',
            dataIndex: 'economicActivity',
            key: 'economicActivity',
            width: 60,
            ...getColumnSearchProps('economicActivity', 'Actividad'),
            render: (text, record) => (
                <span style={{ fontSize: '12px', lineHeight: '0.1' }}>{text}</span>
            )
        },
        {
            title: 'Razón social',
            dataIndex: 'description',
            key: 'description',
            width: 70,
            filters: [
                {
                    text: 'Natural',
                    value: 'NATURAL',
                },
                {
                    text: 'Juridica',
                    value: 'JURIDICA',
                },
            ],
            onFilter: (value: string | number | boolean, record) => {
                if (typeof value === 'string') {
                    return record.description.indexOf(value) === 0;
                }
                return false;
            },
            sorter: (a, b) => {
                const dateA = new Date(a.description);
                const dateB = new Date(b.description);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },

        },
        {
            title: 'País',
            dataIndex: 'msCatalogueCountryName',
            key: 'msCatalogueCountryName',
            width: 40,
            ...getColumnSearchProps('msCatalogueCountryName', 'pais'),
        },
        {
            title: 'Estado',
            dataIndex: 'status',
            key: 'status',
            width: 40,
            filters: [
                {
                    text: 'Activo',
                    value: 'ACTIVO',
                },
                {
                    text: 'Inactivo',
                    value: 'INACTIVO',
                },
            ],
            onFilter: (value: string | number | boolean, record) => {
                if (typeof value === 'string') {
                    return record.status.indexOf(value) === 0;
                }
                return false;
            },
        },
        {
            title: 'Tipo',
            dataIndex: 'type',
            key: 'type',
            width: 30,
        },
        {
            title: 'Creado',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 40,
            defaultSortOrder: 'descend',
            sorter: (a, b) => {
                const dateA = new Date(a.createdAt);
                const dateB = new Date(b.createdAt);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },
            ...getColumnSearchProps('createdAt', 'creado'),
        },
        {
            title: '',
            key: 'operation',
            fixed: 'right',
            width: 50,

            render: (record: DataTypePortafolio) =>
                <Space size="middle">
                    <Tooltip placement="topRight" title={"Visualizar resultados"} >
                        <Button
                            type="text"
                            className={style["update-button"]}
                            onClick={() => {
                                setIsResults(true);
                                setUserData(record);
                            }}

                            icon={<AreaChartOutlined  />}
                        />
                    </Tooltip>

                    <Tooltip placement="topRight" title={validateMessages.registerGeiPortfolio} >
                        <Button
                            type="text"
                            className={style["update-button"]}
                            onClick={() => handleOpenModalPortafolio(record)}
                            icon={<FundOutlined />}
                        />
                    </Tooltip>

                    <Tooltip placement="topRight" title={validateMessages.registerUser}>
                        <Button
                            type="text"
                            className={style["update-button"]}
                            onClick={() => showModalUser(record)}
                            style={{ display: portfolioReadOnly ? "none" : "inline-block" }}
                            icon={<UserOutlined />}
                        />
                    </Tooltip>

                    <Tooltip placement="topRight" title={validateMessages.updateButton}>
                        <Button
                            type="text"
                            className={style["update-button"]}
                            onClick={() => showModalUpdate(record)}
                            style={{ display: portfolioReadOnly ? "none" : "inline-block" }}
                            icon={<EditOutlined />}
                        />
                    </Tooltip>

                    {record.status === "ACTIVO" && (
                        <Tooltip placement="topRight" title={validateMessages.deleteButton}>
                            <Button
                                type="text"
                                className={style["danger-button"]}
                                onClick={() => updateOrganization(record)}
                                style={{ display: portfolioReadOnly ? "none" : "inline-block" }}
                                icon={<DeleteOutlined />}
                            />
                        </Tooltip>
                    )}



                    <Tooltip placement="topRight" title={validateMessages.deleteButton} >
                        <Button
                            type="text"
                            className={style["eliminate-button"]}
                          style={{ display: portfolioReadOnly ? "none" : "inline-block" }}
                            onClick={() => {
                                setUserData(record);
                                setIsModalDeleteOrg(true);
                            }}
                            icon={<CloseCircleOutlined />}
                        />
                    </Tooltip>


                </Space>,
        },

    ];


    const columnsEmissions: ColumnsType<DataTypeEmission> = [
        {

            title: 'Nombre',
            width: 25,
            dataIndex: 'name',
            key: 'name',

        },
        {
            title: 'Tipo',
            width: 20,
            dataIndex: 'type',
            key: 'type',
        },
        {
            title: '',
            key: 'operation',
            fixed: 'right',
            width: 20,

            render: (record: DataTypeEmission) =>
                portfolioReadOnly ? null : (
                <Space size="middle">
                    <Tooltip placement="topRight" title={validateMessages.deleteButton} >
                        <Button
                            type="text"
                            className={style["danger-button"]}
                            onClick={() => deleteEmissionsOrganiations(record.emissionOrganizationId)}
                            icon={<CloseCircleOutlined />}
                        >

                        </Button>
                    </Tooltip>


                </Space>
                ),
        },


    ];

    const columnsLoans: ColumnsType<Loan> = [
        {
            title: '',
            width: 0,
            dataIndex: 'id',
            key: 'id',
            render: () => null,
        },
        {
            title: '',
            width: 0,
            dataIndex: 'msIdentityOrganizationName',
            key: 'msIdentityOrganizationName',
            render: () => null,
        },
        {
            title: '',
            width: 0,
            dataIndex: 'msIdentityOrganizationRuc',
            key: 'msIdentityOrganizationRuc',
            render: () => null,
        },

        {
            title: 'Patrimonio Total',
            width: 30,
            dataIndex: 'totalAssets',
            key: 'totalAssets',
        },
        {
            title: 'Deuda Total',
            width: 30,
            dataIndex: 'totalDebt',
            key: 'totalDebt',
        },
        {
            title: 'Fecha de Préstamo',
            width: 40,
            dataIndex: 'initialLoanDate',
            key: 'initialLoanDate',
            render: (date: string) => date ? dayjs(date).format('DD/MM/YYYY') : 'Sin fecha',
        },
        {
            title: 'Fecha de Fin',
            width: 40,
            dataIndex: 'loanEndDate',
            key: 'loanEndDate',
            render: (date: string) => date ? dayjs(date).format('DD/MM/YYYY') : 'Sin fecha',
        },
        {
            title: 'Tipo de Préstamo',
            width: 30,
            dataIndex: 'typeLoan',
            key: 'typeLoan',
        },
        {
            title: 'Estado',
            width: 30,
            dataIndex: 'status',
            key: 'status',
            sorter: (a: Loan, b: Loan) => a.status.localeCompare(b.status)
        },
        {
            title: '',
            width: 0,
            dataIndex: 'quantityLoan',
            key: 'quantityLoan',
            render: () => null,
        },

        {
            title: '',
            key: 'operation',
            fixed: 'right',
            width: 40,
            render: (record: Loan) => (
                <Space size="middle">

                    <Popconfirm
                        title="¿Desea cerrar el portafolio?"
                        open={openPopconfirmId === record.id}
                        onOpenChange={(visible) => {
                            if (visible) {
                                setOpenPopconfirmId(record.id);
                            } else {
                                setOpenPopconfirmId(null);
                            }
                        }}
                        onConfirm={() => {
                            closePortfolio(record);
                            setOpenPopconfirmId(null); // cerrar después de confirmar
                        }}
                        onCancel={handleCancelPop}
                    >
                        <Button
                            type="text"
                            className={style["close-button"]}
                            onClick={() => showPopconfirm(record.id)}
                            style={{ display: portfolioReadOnly ? "none" : "inline-block" }}
                            icon={<FolderAddOutlined />}
                        />
                    </Popconfirm>

                    <Tooltip placement="topRight" title="Agregar data de actividad">
                        <Button
                            type="text"
                            className={style["update-button"]}
                            onClick={() => handleActivityData(true, record)}
                            style={{
                                display:
                                    portfolioReadOnly && record.status.trim() === 'CERRADO'
                                        ? 'none'
                                        : 'inline-block',
                            }}
                            icon={<ExperimentOutlined />}
                        />
                    </Tooltip>
                    <Tooltip placement="topRight" title="Actualizar">
                        <Button
                            type="text"
                            className={style["update-button"]}
                            onClick={() => setLoanUpdate(record)}
                            style={{ display: portfolioReadOnly ? "none" : "inline-block" }}
                            icon={<EditOutlined />}
                        />
                    </Tooltip>
                    <Tooltip placement="topRight" title="Eliminar">
                        <Button
                            type="text"
                            className={style["eliminate-button"]}
                            onClick={() => setLoanDelete(record)}
                            style={{ display: portfolioReadOnly ? "none" : "inline-block" }}
                            icon={<CloseCircleOutlined />}
                        />
                    </Tooltip>
                </Space>

            ),
        },



    ];

    const closePortfolio = async (record: Loan) => {
        const updateStatusPortfolio = {
            PortfolioId: record.id,
            Status: "CERRADO",
        };
        await props.putStatusPortfolio(updateStatusPortfolio);
        const responseData = await props.getPortfolio(userData?.organizationParentId);
        setDataTablePortfolio(responseData);
    }

    const handleActivityData = async (state: boolean, record: Loan) => {
        setActivityDataModal(true)
        const responseData = await props.getActivityDataPortfolio(record.id);
        setIsLoan(record);
        setActivityDataPortfolio(responseData);
    }

    const setLoanUpdate = async (record: Loan) => {
        setIsLoan(record);

        formPortfolio.resetFields()
        let formattedDate: Dayjs | null = null;





        formPortfolio.setFieldsValue({
            totalAssets: record.totalAssets,
            totalDebt: record.totalDebt,
            initialLoanDate: formattedDate,

        });
        setType(false);
    }

    const setLoanDelete = async (record: Loan) => {
        setIsModalDeleteMethodOpen(true);
        setIsLoan(record);
    }

    const deleteLoan = async (values: any) => {

        const updateStatusPortfolio = {
            PortfolioId: isLoan?.id,
            Status: "INACTIVO",
            Observation: values.observation
        };
        await props.putStatusPortfolio(updateStatusPortfolio);
        setIsModalDeleteMethodOpen(false);
        const responseData = await props.getPortfolio(userData?.organizationParentId);
        setDataTablePortfolio(responseData);
    }

    const handleOk = () => {
        form.resetFields();
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        form.resetFields();
        setIsModalOpen(false);
    };
    const handleOkForm = () => {
        form.resetFields();
        //setIsModalOpenForm(false);
    };
    const handleCancelForm = () => {
        form.resetFields();
        setIsModalOpenForm(false);
    };
    const handleDeleteOk = async () => {
        setIsModalDeleteOpen(false);
        await props.deleteInactiveOrganization(userData?.id);
        const responseDataEstablishment = await props.getOrganizationsByParentOrganizationId(props.organizationObject?.id);
        setDataTableOrganization(responseDataEstablishment);
    };
    const handleValidateUserOk = async () => {
        setIsModalValidateUse(false);
    };

    const handleValidateInactiveUserOk = async () => {
        const registerUser = {
            id: userData?.id
        };
        await props.putActiveOrganization(registerUser);
        const responseDataEstablishment = await props.getOrganizationsByParentOrganizationId(props.organizationObject?.id);
        setDataTableOrganization(responseDataEstablishment);
        setIsModalValidateInactiveUser(false);
    };
    const handleDeleteCancel = () => {
        setIsModalDeleteOpen(false);
    };
    const handleValidateUserCancel = () => {
        setIsModalValidateUse(false);
    };
    const handleValidateInactiveUserCancel = () => {
        setIsModalValidateInactiveUser(false);
    };
    const onFormLayoutChange = ({ size }: { size: SizeType }) => {
        setComponentSize(size);
    };

    const showModalCreate = async () => {
        setIsFormValidate(true);
        setIsModalOpen(true);
        setTypeModal(true);
        const responseData = await props.getTypeOrganization();
        setSelectDataTableTypeOrganization(responseData);

    };
    const [isModalUser, setIsModalUser] = useState(false);
    const showModalUser = async (value: DataTypePortafolio) => {

        const responseData = await props.getAllUsersPortfolioTable(value.organizationParentId);
        if (responseData.length == 0) {
            setValidateEmptyData(true);

        } else {
            setValidateEmptyData(false);
        }
        setDataTableUser(responseData);
        setUserData(value);
        setIsModalUser(true);

    }
    const showModalUpdate = async (value: DataTypePortafolio) => {

        const responseData = await props.getAllCountry();
        setIsCountry(responseData);
        const responseDataType = await props.getTypeOrganization();
        setSelectDataTableTypeOrganization(responseDataType);
        form.setFieldsValue({

            countryId: value.msCatalogueCountryId, id: value.id, ruc: value.ruc, name: value.name, activity: value.economicActivity,
            description: value.description, country: value.msCatalogueCountryName, typeorg: value.typeId
        });


        setIsModalOpenForm(true);
        setIsFormValidate(false);
        setTypeModal(false);
    };
    const showEmissionModalUpdate = async (value: string) => {
        setIsModalEmision(true);
        setIsId(value);
        const responseDataOrganization = await props.getEmissionsOrganization(value);
        setDataTableEmissions(responseDataOrganization);
        const responseDataOrganizationTable = await props.getAllEmissionsTable(value);
        setSelectDataTableEmissions(responseDataOrganizationTable);

    };


    const showEmissionModalFalse = async () => {
        setIsModalEmision(false);
    };
    const showTransformationModalFalse = async () => {
        setIsModalTransformation(false);
    };
    const deleteEmissionsOrganiations = async (value: string) => {
        //setIsModalEmision(false);
        await props.deleteEmissionsOrganization(value)
        const responseDataOrganization = await props.getEmissionsOrganization(isId);
        setDataTableEmissions(responseDataOrganization);
    };



    const updateOrganization = async (value: DataTypePortafolio) => {
        setUserData(value);
        //form.setFieldsValue({ id: value.id, empresa: value.msBusinessBusinessName, nombre: value.name, dni: value.dni, telefono: value.phone, email: value.email,rol:value.rol });

        setIsModalDeleteOpen(true);

    };
    const onFinish = async (values: any) => {

        const registerUser = {
            id: values.id,
            ruc: values.ruc,
            name: values.name,
            economicActivity: values.activity,
            description: values.description == undefined ? ' ' : values.description,
            countryId: selectedCountry?.id == undefined ? values.countryId : selectedCountry?.id,
            country: selectedCountry?.name == undefined ? values.country : selectedCountry?.name,
            typeOrganizationId: values.typeorg
        };
        handleCancel();
        if (typeModal) {
            await props.postRegisterOrganization(registerUser);
        } else {
            await props.putUpdateOrganization(registerUser);
        }
        const responseDataEstablishment = await props.getOrganizationsByParentOrganizationId(props.organizationObject?.id);
        setDataTableOrganization(responseDataEstablishment);
        setIsModalOpenForm(false);
        form.resetFields();
        handleOkForm();


    };
    const onFinishValidate = async (values: any) => {

        const responseData = await props.getValidateOrganization(values.ruc);
        if (responseData != null) {
            const dataOrganizationParent = {
                OrganizationId: responseData.id,
                ParentOrganizationId: props.organizationObject?.id,
            };
            await props.postOrganizationsByParentOrganizationId(dataOrganizationParent);
            setIsModalOpen(false);
            setIsModalValidateUse(true);

        } else if (responseData != null && responseData.status.trim() == "INACTIVE") {
            const dataUser: DataTypePortafolio = {
                key: "1",
                id: responseData.id,
                ruc: responseData.ruc,
                name: responseData.name,
                economicActivity: "",
                description: "",
                msCatalogueCountryId: "",
                parentOrganizationId: "",
                msCatalogueCountryName: "",
                organizationParentId: "",
                status: "",
                createdAt: "",
                type: "",
                typeId: ""
            };
            setUserData(dataUser);
            setIsModalOpen(false);
            setIsModalValidateInactiveUser(true);

        } else {
            form.setFieldsValue({
                ruc: values.ruc,
            });

            const responseData = await props.getAllCountry();
            setIsCountry(responseData);
            setIsModalOpenForm(true);
            setIsModalOpen(false);
            setIsFormValidate(false);

        }
        const responseDataEstablishment = await props.getOrganizationsByParentOrganizationId(props.organizationObject?.id);
        setDataTableOrganization(responseDataEstablishment);
        formValidate.resetFields();


    };

    const onRegisterEmissions = async (values: any) => {
        const register = {
            emissionSourcesId: values.emissions,
            organizationId: isId
        }
        await props.postResgisterEmissionsOrganization(register);
        const responseDataOrganization = await props.getEmissionsOrganization(isId);
        setDataTableEmissions(responseDataOrganization);
    }
    const initialValues = {
        ruc: 'valor predeterminado aquí', // Establece el valor predeterminado para el campo 'ruc'
    };



    const [isModalDeleteMethodOpen, setIsModalDeleteMethodOpen] = useState(false)
    const [isIdData, setIdData] = useState<DataTypePortafolio>();

    const handleDeleteMethodOk = async () => {
        const responseData = await props.deleteOrganizationsByParentOrganizationId(isIdData?.organizationParentId);
        if (responseData != undefined) {
            const responseDataEstablishment = await props.getOrganizationsByParentOrganizationId(props.organizationObject?.id);
            setDataTableOrganization(responseDataEstablishment);
        }

        setIsModalDeleteMethodOpen(false);
    };
    const handleDeleteMethodCancel = () => {
        setIsModalDeleteMethodOpen(false);
    };
    const handleTypeDeleteButton = async (value: DataTypePortafolio) => {
        setIdData(value);
        setIsModalDeleteMethodOpen(true);

    }

    const handleCountryChange = (selectedId: string) => {
        const selected = isCountry.find((country) => country.id === selectedId);
        setSelectedCountry(selected);
    };
    const onRegisterPortfolio = async (values: any) => {
        const request = {
            MsIdentityOrganizationParentId: userData?.organizationParentId,
            TotalAssets: values.totalAssets,
            TotalDebt: values.totalDebt,
            InitialLoanDate: values.initialLoanDate,
            TypeLoan: values.typeLoan,
            QuantityLoan: values.quantityLoan,
            MsIdentityOrganizationId: userData?.id
        }
        if (isType === false) {
            const request = {
                Id: isLoan?.id,

                TotalAssets: values.totalAssets,
                TotalDebt: values.totalDebt,
                InitialLoanDate: values.initialLoanDate,
                TypeLoan: values.typeLoan,
                QuantityLoan: values.quantityLoan,
                MsIdentityOrganizationId: userData?.id
            }
            await props.putPortfolio(request)
            setType(true)
        } else {
            await props.postPortfolio(request);
        }
        const responseData = await props.getPortfolio(userData?.organizationParentId);
        setDataTablePortfolio(responseData);
        formPortfolio.resetFields();

    }


    const handleOkDelete = async () => {
        if (motivo == undefined || motivo == "" || motivo == null) {
            openNotification("Advertencia", "Ingresar el motivo")
            return
        }
        const request = {
            OrganizationId: userData?.id,
            ParentOrganizationId: props.organizationObject?.id,
            Description: motivo
        }
        await props.postInactiveOrganizationParent(request);
        const responseDataEstablishment = await props.getOrganizationsByParentOrganizationId(props.organizationObject?.id);
        setDataTableOrganization(responseDataEstablishment);
        setMotivo("")
        setIsModalDeleteOrg(false)
    }
    return (
        <>
            <AdminHeader>Organizaciones Asociadas {props.organizationObject?.name == undefined ? "" : "de " + props.organizationObject?.name} </AdminHeader>
            {props.organizationObject != undefined && !portfolioReadOnly && (
                <Button
                    type="primary"
                    icon={<PlusCircleOutlined />}
                    className={style["create-button-user"]}
                    onClick={showModalCreate}
                >
                    Crear organización
                </Button>
            )}
            <Table size="small" columns={columns} dataSource={dataTableOrganization.length > 0 ? dataTableOrganization : props.organizationsTable} scroll={{ x: 1500 }} />
            <Modal open={isModalOpen} onOk={handleOk} onCancel={handleCancel}
                width={350} footer={null}       >
                <AdminHeader className={style["title-modal"]}>
                    {"Validar organización"}
                </AdminHeader>
                <Form
                    form={formValidate}
                    layout="vertical"
                    initialValues={{ requiredMarkValue: requiredMark }}
                    requiredMark={requiredMark}
                    onFinish={onFinishValidate}
                    onValuesChange={onFormLayoutChange}
                    size={componentSize as SizeType}
                >
                    <Form.Item label="RUC" name="ruc" rules={[
                        { required: true, message: validateMessages.emptyField }
                    ]}>
                        <Input placeholder="Ingresar RUC" />
                    </Form.Item>
                    <Form.Item>
                        <Button className={style["create-button-user"]} type="primary" htmlType="submit">
                            Validar
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
            <Drawer title={typeModal ? "Crear una nueva organización" : "Actualizar organización"} open={isModalOpenForm} onClose={handleCancelForm} width={350} footer={null}>
                <Form
                    form={form}
                    layout="vertical"
                    initialValues={{ requiredMarkValue: requiredMark }}
                    requiredMark={requiredMark}
                    onFinish={onFinish}
                    onValuesChange={onFormLayoutChange}
                    size={componentSize as SizeType}
                >
                    <Form.Item style={{ display: 'none' }} label="" name="id" >
                        <Input />
                    </Form.Item>
                    <Form.Item style={{ display: 'none' }} label="" name="countryId" >
                        <Input />
                    </Form.Item>

                    <Form.Item label="RUC" name="ruc" rules={[{ required: true, message: validateMessages.emptyField }, { validator: (_, value) => validateDigitLength(value) },]}>
                        <Input disabled={true} placeholder="Ingresar RUC" />
                    </Form.Item>
                    <Form.Item label="Nombre" name="name" rules={[{ required: true, message: validateMessages.emptyField }, { validator: (_, value) => validateAndLength(value) },]}>
                        <Input placeholder="Ingresar nombre" />
                    </Form.Item>

                    <Form.Item name="activity" label="Actividad económica" rules={[{ required: true, message: validateMessages.emptyField }, { validator: (_, value) => validate150(value) }]}>
                        <Input placeholder="Ingresar actividad económica" />
                    </Form.Item>
                    <Form.Item name="description" label="Razón social" >
                        <Input placeholder="Ingresar razón social" />
                    </Form.Item>
                    <Form.Item label="País" name="country" rules={[{ required: true, message: validateMessages.emptyField }]}>
                        <Select
                            style={{ width: "100%" }}
                            onChange={handleCountryChange} // Establece el ID del país seleccionado
                            value={selectedCountry?.id} // El valor debe ser el ID del país seleccionado
                            placeholder="Escoge un país"
                        >
                            {isCountry.map((country: Country) => (
                                <Option key={country.id} value={country.id}>
                                    {country.name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item label="Tipo" name="typeorg" rules={[{ required: true, message: validateMessages.emptyField }]}>
                        <Select
                            showSearch
                            style={{ width: "100%" }}
                            onChange={(type: EmissionsSource) => setSearchValue(type)}
                            filterOption={(input: any, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }

                            value={searchValue}
                            placeholder="Escoga el tipo de organización"
                        >
                            {selectDataTableTypeOrganization.map((type: TypeOrganization) => (
                                <Option key={`type-option-${type}`} value={type.id}
                                >
                                    {type.name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item>
                        <Button className={style["user-button"]} type="primary" htmlType="submit">
                            {typeModal ? "Agregar" : "Actualizar"}
                        </Button>
                    </Form.Item>
                </Form>
            </Drawer>
            <Modal open={isModalDeleteOpen} onOk={handleDeleteOk} onCancel={handleDeleteCancel}>
                <h3>¿Esta seguro de inactivar a la organización {userData?.name} con cédula {userData?.ruc}? </h3>
            </Modal>

            <Modal open={isModalValidateInactiveUser} onOk={handleValidateInactiveUserOk} onCancel={handleValidateInactiveUserCancel}>
                <h3>La organización {userData?.name} con ruc {userData?.ruc} se encuentra inactivo. <br /> ¿Deseas activarlo? </h3>
            </Modal>

            <Drawer open={isModalEmision} width={950} footer={null} /*onOk={showEmissionModalFalse}*/ onClose={showEmissionModalFalse}>

                <h3>Seleccionar fuentes de emisión</h3>
                <Form
                    form={form}
                    layout="inline"
                    initialValues={{ requiredMarkValue: requiredMark }}
                    requiredMark={requiredMark}
                    onFinish={onRegisterEmissions}
                    onValuesChange={onFormLayoutChange}
                    size={componentSize as SizeType}
                >
                    <Form.Item className={style["select-fe"]} name="emissions" rules={[{ required: true, message: validateMessages.emptyField }]}>
                        <Select

                            showSearch
                            style={{ width: "100%" }}
                            onChange={(type: EmissionsSource) => setSearchValue(type)}
                            filterOption={(input: any, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }

                            value={searchValue}
                            placeholder="Escoga la fuente de emisión"
                        >
                            {selectDataTableEmissions.map((type: EmissionsSource) => (
                                <Option key={`type-option-${type}`} value={type.id}
                                >
                                    {type.name + "-" + type.flow}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>


                    <Form.Item  >
                        {!portfolioReadOnly && (
                        <Button
                            htmlType="submit"
                            type="primary"
                            className={style["create-button-user-select"]}
                        >
                            Guardar selección
                        </Button>
                        )}
                    </Form.Item>
                </Form>
                <Table size="small" columns={columnsEmissions} dataSource={dataTableEmissions} scroll={{ x: 500 }} />
                <LoadingIndicator />
            </Drawer>
            <Modal open={isModalDeleteMethodOpen} onOk={handleDeleteMethodOk} onCancel={handleDeleteMethodCancel}>
                <h3>¿Esta seguro que desea eliminar la Organización? </h3>
            </Modal>
            <Drawer open={isModalUser} width={1200} footer={null} onClose={() => setIsModalUser(false)}>
                <TUser validatePortfolio={true} organizationParentId={userData?.organizationParentId} usersPortfolioTable={dataTableUser} />
                <LoadingIndicator />
            </Drawer>
            <Drawer open={isModalPortfolio} width={'100%'} footer={null} /*onOk={showEmissionModalFalse}*/ onClose={() => setIsModalPortfolio(false)}>
                <AdminHeader>Portafolio GEI {" " + userData?.name}</AdminHeader>
                <TGeiInventoryPortafolio organizationData={userData} organizationObject={props.organizationObject} />
                {/* <Form
                    form={formPortfolio}
                    layout="vertical"
                    initialValues={{ requiredMarkValue: requiredMark }}
                    requiredMark={requiredMark}
                    onFinish={onRegisterPortfolio}
                    onValuesChange={onFormLayoutChange}
                    style={{ display: props.editView ? "none" : "grid" }}
                    size={componentSize as SizeType}
                >
                    <Form.Item name="totalAssets" label="Patrimonio total" rules={[{ required: true, message: validateMessages.emptyField }, { validator: (_, value) => validateNumber(value) }]}>
                        <Input placeholder="Ingresar patrimonio total" />
                    </Form.Item>
                    <Form.Item name="totalDebt" label="Deuda total " rules={[{ required: true, message: validateMessages.emptyField }, { validator: (_, value) => validateNumber(value) }]}>
                        <Input placeholder="Ingresar deuda total" />
                    </Form.Item>
                    <Form.Item name="initialLoanDate" label="Fecha de préstamo" rules={[{ required: true, message: validateMessages.emptyField }]}>
                        <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} placeholder="Ingresar fecha de préstamo" />
                    </Form.Item>
                    <div style={{ marginBottom: "10px" }}>Vigencia del prestamo</div>
                    <Row >

                        <Col>
                            <Form.Item name="quantityLoan" rules={[{ required: true, message: validateMessages.emptyField }]}>
                                <InputNumber placeholder='Cant.' min={1} style={{ display: 'flex' }} />
                            </Form.Item>
                        </Col>
                        <Col style={{ width: "25%" }}>
                            <Form.Item name="typeLoan" rules={[{ required: true, message: validateMessages.emptyField }]}>
                                <Select style={{ width: "100%" }}
                                    placeholder="Ingresar tipo">
                                    <Option value="ANUAL">Anual</Option>
                                    <Option value="MENSUAL">Mensual</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>


                    <Form.Item>
                        <Button className={style["user-button"]} type="primary" htmlType="submit">
                            {isType ? "Agregar" : "Actualizar"}
                        </Button>
                    </Form.Item>

                </Form> 
                <Table size="small" columns={columnsLoans} dataSource={dataTablePortfolio} scroll={{ x: 500 }} /> */}
            </Drawer>


            <Modal open={isModalDeleteMethodOpen} onCancel={handleDeleteMethodCancel} footer={null}>
                <h3>¿Esta seguro que desea eliminar el portafolio? </h3>
                <Form form={formInactivePortfolio}
                    layout="vertical"
                    initialValues={{ requiredMarkValue: requiredMark }}
                    requiredMark={requiredMark}
                    onFinish={deleteLoan}
                    onValuesChange={onFormLayoutChange}
                    size={componentSize as SizeType}
                >
                    {/* Campos que solo se muestran en modo "Crear" */}
                    <>
                        <Form.Item
                            name="observation"
                            label="Motivo"
                            rules={[{ required: true, message: "Por favor ingrese un motivo para Inactivar" }]}
                        >
                            <Input placeholder="Motivo para inactivar" />
                        </Form.Item>
                        <Form.Item>
                            <Button className={style["danger-button"]} type="primary" htmlType="submit">
                                {"Inactivar"}
                            </Button>
                        </Form.Item>
                    </>
                </Form>
            </Modal>
            {/* <TActivityDataPortfolio showModal={isActivityDataModal} closeDrawer={() => setActivityDataModal(false)} Portfolio={isLoan} DataActivity={isActivityDataPortfolio} />
             */}
            <Modal open={isModalDeleteOrg} onOk={handleOkDelete} onCancel={() => setIsModalDeleteOrg(false)}>
                <AdminHeader>¿Desa eliminar la organización?</AdminHeader>
                {<p> {"Escribir el motivo por el cual se elimina la organización " + userData?.name}</p>}
                {<TextArea
                    value={motivo}
                    onChange={(e) => setMotivo(e.target.value)}
                    placeholder="Ingrese el motivo aquí..."
                />}
            </Modal>
            <Drawer open={isResults} width={'100%'} footer={null} /*onOk={showEmissionModalFalse}*/ onClose={() => setIsResults(false)}>
                <ResultsUnified typeResult={"PORTAFOLIO"} oneResult={true} organization={userData} />
                <LoadingIndicator/>
            </Drawer>
        </>
    );


};

const mapStateToProps = (state: AppState) => ({

});

export default connect(mapStateToProps, {
    getValidateOrganization, putActiveOrganization, postRegisterOrganization, putUpdateOrganization,
    getOrganizationById, deleteInactiveOrganization, getAllEmissionsTable, getEmissionsOrganization,
    postResgisterEmissionsOrganization, deleteOrganizationById, deleteEmissionsOrganization, getAllTransformation, GetTransformationById, postRegisterTransformation, putUpdateTransformation,
    getAllCountry, getOrganizationsByParentOrganizationId,
    postOrganizationsByParentOrganizationId, deleteOrganizationsByParentOrganizationId, getTypeOrganization,
    getAllUsersPortfolioTable, getPortfolio, postPortfolio, putStatusPortfolio, putPortfolio, getActivityDataPortfolio,
    postInactiveOrganizationParent,
    getOrgObservations
})(TPortafolioOrganizations);